// extracted by mini-css-extract-plugin
export var button = "styles-module--button--21ume";
export var buttonOutline = "styles-module--buttonOutline--2NuJl";